import React, { Component } from "react";
import PropTypes from "prop-types";

import { SelectionBox } from "./SelectionBox";
import { convertIdToReal, DATE_OPTIONS_LIST } from "./NuDateUtils";
import { EFFECTIVE_EVENT as DEFAULT_DATE_TYPE } from "./constants/dateConstants";

export class SimplifiedSelectDateRange extends Component {
    handleInputChange = e => {
        const selection = convertIdToReal(e.target.value);
        const date = {
            startDate: selection.startDate,
            endDate: selection.endDate,
            dateType: DEFAULT_DATE_TYPE,
            rangeId: selection.id
        };
        this.props.dateChanged(undefined, date);
    };

    fireSearch = (startDate, endDate, rangeId) => {
        const date = { startDate, endDate, dateType: DEFAULT_DATE_TYPE, rangeId };
        this.props.dateChanged(undefined, date);
    };

    render() {
        const options = DATE_OPTIONS_LIST.map(opt => ({
            value: opt.id,
            display: opt.display
        }));
        return (
            <SelectionBox
                options={options}
                handleSelect={this.handleInputChange}
                value={this.props.value}
                aria-label="select a date range"
            />
        );
    }
}

SimplifiedSelectDateRange.propTypes = {
    dateChanged: PropTypes.func,
    submitPressed: PropTypes.func,
    floated: PropTypes.bool,
    value: PropTypes.string
};
